"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const type_1 = require("./type");
function listSuperReducer(state, action) {
    if (action.type === type_1.ActionType.FETCH_DATA_REQUEST) {
        return {
            ...state,
            loading: true
        };
    }
    if (action.type === type_1.ActionType.FETCH_DATA_SUCCESS) {
        const { data, numberOfTotalRows } = action.payload;
        return {
            ...state,
            loading: false,
            data,
            numberOfTotalRows
        };
    }
    if (action.type === type_1.ActionType.FILTER_CHANGE) {
        const { filters, pageIdx } = action.payload;
        return {
            ...state,
            filters,
            pageIdx
        };
    }
    if (action.type === type_1.ActionType.ORDER_CHANGE) {
        const { sortDescAsc, sortAttribute, pageIdx } = action.payload;
        return {
            ...state,
            sortDescAsc,
            sortAttribute,
            pageIdx
        };
    }
    if (action.type === type_1.ActionType.PAGE_CHANGE) {
        const { pageIdx } = action.payload;
        return {
            ...state,
            pageIdx
        };
    }
    return state;
}
exports.default = listSuperReducer;
